import { useShowContextRequired } from 'ui-builder';
import { get } from 'lodash';
import React from 'react';
import { IconButton, IconType } from '../IconButton';

export function CopyValueToClipboard(props: { text: string }) {
  const [copied, setCopied] = React.useState(false);

  return (
    <IconButton
      onClick={() => {
        navigator.clipboard.writeText(props.text);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 500);
      }}
      type={copied ? IconType.DONE : IconType.COPY}
    />
  );
}

export function CopyTextToClipboard(props: { source: string }) {

  const showContext = useShowContextRequired<{ entry: string }>();

  const text = get(showContext.data, props.source);

  return (
    <CopyValueToClipboard text={text} />
  );
}
